<script setup lang="ts">
  import IconQC from '@qicgroupdoha/qic-connect-ds/components/IconQC'
</script>

<template>
  <div class="quote-reminder text-small-medium">
    <!-- @vue-ignore -->
    <IconQC name="lock" size="sm" :color="$qicConnect.colors.icn.srf.tertiary" />
    {{ $t('qic_ssl_reminder') }}
  </div>
</template>

<style lang="scss" scoped>
  .quote-reminder {
    padding: var(--spacing-5) var(--spacing-7);
    display: flex;
    align-items: center;
    justify-content: center;
    gap: var(--spacing-2);
  }
</style>
